import { ReactElement } from 'react';
import { ProjectDetailsImagesContainer } from '../../../modules/projectDetails/sub/images/containers/ProjectDetailsImages.container';

export const ProjectDetailsImagesView = (): ReactElement => <ProjectDetailsImagesContainer />;
